import React, { useState } from 'react'
import { DropdownItem } from "reactstrap"
import ActionUnhidePartner from './ActionUnhidePartner'
import { canManagePartner, getNoPermissionMessage } from '../../../helpers/partnerPermission'

const ActionList = (props) => {
    const {listSelected, isOpen, showModal, closeModal, partners} = props

    // Lọc các partner được chọn
    const selectedPartners = partners.filter(partner => listSelected.includes(partner._id))
    const isEnabled = selectedPartners.some(p => p.hidden === false)
    const canManage = canManagePartner()

    return (
        <div>
            {canManage ? (
                <DropdownItem onClick={showModal} disabled={isEnabled}>Hiện đối tác</DropdownItem>
            ) : (
                // DropdownItem disabled không bắt sự kiện chuột -> đặt title ở div bọc ngoài
                <div title={getNoPermissionMessage('hiện lại')}>
                    <DropdownItem disabled>Hiện đối tác</DropdownItem>
                </div>
            )}
            <ActionUnhidePartner
                isOpen={isOpen}
                closeModal={closeModal}
                listSelected={listSelected}
                partners={partners}
            />
        </div>
    )
}

export default ActionList
